/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Upload_RequestingInputs */

const en_toast_upload_requesting = /** @type {(inputs: Toast_Upload_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requesting conversion`)
};

const es_toast_upload_requesting = /** @type {(inputs: Toast_Upload_RequestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitando conversión`)
};

/**
* | output |
* | --- |
* | "Requesting conversion" |
*
* @param {Toast_Upload_RequestingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_requesting = /** @type {((inputs?: Toast_Upload_RequestingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_RequestingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_requesting(inputs)
	return en_toast_upload_requesting(inputs)
});